import { DefaultTheme } from 'styled-components';

import { exportModalLightTheme } from '../app-v2/components/export-modal';
import { uploadInstructionsLightTheme } from '../app/components/upload-instructions-modal';

import { alertBoardConfigTheme } from './component-themes/alert-board-config-theme';
import { alertBoardFilterTheme } from './component-themes/alert-board-filter-theme';
import { alertBoardTheme } from './component-themes/alert-board-theme';
import { alertPreviewTheme } from './component-themes/alert-preview-theme';
import { alertLightTheme } from './component-themes/alert-theme';
import { alertTicketDetailTheme } from './component-themes/alert-ticket-detail-theme';
import { annotationTheme } from './component-themes/annotation-theme';
import { assessVisualizerTheme } from './component-themes/assess-visualizer-theme';
import bulkActionsTheme from './component-themes/bulk-actions-theme';
import { chartLightTheme } from './component-themes/chart-theme';
import { checkboxLightTheme } from './component-themes/checkbox-theme';
import { confirmEmailLightTheme } from './component-themes/confirm-email';
import { customTableTheme } from './component-themes/custom-table-theme';
import { datePickerLightTheme } from './component-themes/date-picker-theme';
import { dateTimeRangePickerLightTheme } from './component-themes/date-time-range-picker-theme';
import { deleteDataModalLightTheme } from './component-themes/delete-data-modal-theme';
import { ensembleTheme } from './component-themes/ensembled-theme';
import { fileUploadModalLightTheme } from './component-themes/file-upload-theme';
import { folderTreeV2Theme } from './component-themes/folder-tree-v2-theme';
import { globalTheme } from './component-themes/global-theme';
import { headerV2Light } from './component-themes/header-theme';
import { headerLightThemeSystem } from './component-themes/header-theme-system';
import { headerLightThemeTag } from './component-themes/header-theme-tag';
import { heatmapLightTheme } from './component-themes/heatmap-theme';
import { investigateLightTheme } from './component-themes/investigate-theme';
import { knobLightTheme } from './component-themes/knob-theme';
import { limitLightTheme } from './component-themes/limit-theme';
import { managePageTheme } from './component-themes/manage-theme';
import { modalLightTheme } from './component-themes/modal-theme';
import { modelAlertsTheme } from './component-themes/model-alerts-theme';
import { modelManagerTheme } from './component-themes/model-manager-theme';
import { modelVisualizerTheme } from './component-themes/model-visualizer-theme';
import { radioButtonLightTheme } from './component-themes/radio-button-theme';
import { scrollBarLightTheme } from './component-themes/scrollbar-theme';
import { searchLightTheme } from './component-themes/search-theme';
import { sidebarLightTheme, sidebarV2Light } from './component-themes/sidebar-theme';
import { sliderLightTheme } from './component-themes/slider-theme';
import { switchLightTheme } from './component-themes/switch-theme';
import { systemBrowserLightTheme } from './component-themes/system-browser-theme';
import { tabTheme } from './component-themes/tab-theme';
import { tenantSelectorTheme } from './component-themes/tenant-selector';
import { textInputLightTheme } from './component-themes/text-input-theme';
import {
  timeDisplayLightTheme,
  timeDisplayLightThemeV2,
} from './component-themes/timedisplay-theme';
import { timelineLightTheme } from './component-themes/timeline-theme';
import { timeSearchLightTheme } from './component-themes/timesearch-theme';
import { tooltipLightTheme } from './component-themes/tooltip-theme';
import { userPreferencesLightTheme } from './component-themes/user-preferences-theme';
import { viewControlsTheme } from './component-themes/view-controls-theme';

import {
  buttonLightTheme,
  dropdownLightTheme,
  resizablePanelLightTheme,
  selectLightTheme,
} from '@controlrooms/components';
import { iconLightTheme } from '@controlrooms/components';
import { datePickerTheme as datePickerV2Theme } from '@controlrooms/components/src/date-picker-v2/date-picker-theme';
import { dataTableTheme } from '@controlrooms/components/src/table/table-theme';
import { colors } from '@controlrooms/design-tokens';

export const lightTheme: DefaultTheme = {
  name: 'Light',
  v2: {
    header: headerV2Light,
    sidebar: sidebarV2Light,
    timeDisplay: timeDisplayLightThemeV2,
    tab: tabTheme.light,
  },
  backgroundColor: colors.k[100],
  reportFilterbackgroundColor: colors.k[100],
  textColor: colors.k[0],
  linkColor: colors.focus.dark[3],
  navigation: {
    textColor: '#b6b6b6',
    borderColor: colors.k[100],
    active: {
      textColor: colors.k[100],
      borderColor: colors.k[100],
    },
  },
  button: buttonLightTheme,
  sidebar: sidebarLightTheme,
  chart: chartLightTheme,
  checkbox: checkboxLightTheme,
  datePicker: datePickerLightTheme,
  dateTimeRangePicker: dateTimeRangePickerLightTheme,
  deleteDataModal: deleteDataModalLightTheme,
  exportModal: exportModalLightTheme,
  tooltip: tooltipLightTheme,
  heatmap: heatmapLightTheme,
  modal: modalLightTheme,
  uploadInstructions: uploadInstructionsLightTheme,
  fileUploadModal: fileUploadModalLightTheme,
  radioButton: radioButtonLightTheme,
  timeDisplay: timeDisplayLightTheme,
  systemHeader: headerLightThemeSystem,
  select: selectLightTheme,
  tagHeader: headerLightThemeTag,
  switch: switchLightTheme,
  systemBrowser: systemBrowserLightTheme,
  scrollBar: scrollBarLightTheme,
  search: searchLightTheme,
  textInput: textInputLightTheme,
  confirmEmail: confirmEmailLightTheme,
  userPreferences: userPreferencesLightTheme,
  timeLine: timelineLightTheme,
  slider: sliderLightTheme,
  alert: alertLightTheme,
  timeSearch: timeSearchLightTheme,
  limit: limitLightTheme,
  knob: knobLightTheme,
  investigate: investigateLightTheme,
  folderTreeV2: folderTreeV2Theme.light,
  resizablePanel: resizablePanelLightTheme,
  tenantSelector: tenantSelectorTheme.light,
  managePage: managePageTheme.light,
  modelAlerts: modelAlertsTheme.light,
  modelManager: modelManagerTheme.light,
  modelVisualizer: modelVisualizerTheme.light,
  alertTicketDetail: alertTicketDetailTheme.light,
  datePickerv2: datePickerV2Theme.light,
  viewControls: viewControlsTheme.light,
  assessVisualizer: assessVisualizerTheme.light,
  ensemble: ensembleTheme.light,
  alertBoard: alertBoardTheme.light,
  alertBoardConfig: alertBoardConfigTheme.light,
  alertBoardFilter: alertBoardFilterTheme.light,
  alertPreview: alertPreviewTheme.light,
  bulkActions: bulkActionsTheme.light,
  customTable: customTableTheme.light,
  dataTable: dataTableTheme.light,
  dropdown: dropdownLightTheme,
  annotation: annotationTheme.light,
  icon: iconLightTheme,
  global: globalTheme.light,
};
